import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const FilteredSetViewNRO = lazy(() =>
  import("@scenes/Catalogs/FilteredSetViewNRO").then((module) => ({
    default: module.FilteredSetViewNRO,
  }))
);

export const dashboardCatalogsCatalogIdSelectionSelectionNameNRO: NavigationRoutingObject = {
  Component: FilteredSetViewNRO,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-catalogs-catalog-id-nro-heading", "Dashboard Catalogs Catalog Id"),
  pageNameForTracking: () => "Dashboard Catalogs Catalog Id",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-catalogs-catalog-id-nro-description", "Edit catalog"),
  icon: "nav-system-catalog",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/catalogs/:appGroupId",
};
